import { SelectionDropdown } from "../../../../../../components/Dropdown/SelectionDropdown.tsx";
import { InputNumber } from "../../../../../../components/InputNumber/InputNumber.tsx";
import type { RgbaColor } from "../../../../../../types.ts";
import { MAX_PIXEL_DIMENSION } from "../../../../../constants.ts";
import { PanelSection } from "../../../../components/Panel/PanelSection.tsx";
import { PanelSubsection } from "../../../../components/Panel/PanelSubsection.tsx";
import { GENERATION_RATIOS } from "../../../../constants.ts";
import { GENERATION_RATIO_DISPLAY } from "../../../../display.ts";
import type { GenerationRatio } from "../../../../types.ts";
import { DEFAULT_BACKGROUND_COLOR } from "../../Designer/constants.ts";
import { designerCanvasStore } from "../../Designer/stores/designerCanvasStore.ts";
import { DesignerColorPickerButton } from "../../Tools/components/DesignerSettings/DesignerColorPickerButton.tsx";
import { aspectRatioToDimensions } from "../../Tools/EditAsset/Expand/constants.ts";

type BackgroundRatio = "custom" | GenerationRatio;

const BACKGROUND_RATIO_OPTIONS: {
  value: BackgroundRatio;
  label: string;
  extraInfo?: string;
}[] = [
  { value: "custom", label: "Custom" },
  ...GENERATION_RATIOS.map((ratio) => ({
    value: ratio,
    label: GENERATION_RATIO_DISPLAY[ratio].label,
    extraInfo: GENERATION_RATIO_DISPLAY[ratio].extraInfo,
  })),
];

export const CanvasSettingsSection = () => {
  const { canvasSize, backgroundColor } = designerCanvasStore.useState();

  return (
    <PanelSection title="Canvas">
      <PanelSubsection
        title="Color"
        rightItem={
          <DesignerColorPickerButton
            color={backgroundColor ?? DEFAULT_BACKGROUND_COLOR}
            onColorChange={(color: RgbaColor) =>
              designerCanvasStore.setBackgroundColor(color)
            }
            size="sm"
          />
        }
      />
      <PanelSubsection
        title="Aspect Ratio"
        rightItem={
          <SelectionDropdown
            value={
              GENERATION_RATIOS.find(
                (ratio) =>
                  aspectRatioToDimensions[ratio].width === canvasSize?.width &&
                  aspectRatioToDimensions[ratio].height === canvasSize.height,
              ) ?? "custom"
            }
            onChange={(ratio) => {
              if (ratio !== "custom") {
                const dimensions = aspectRatioToDimensions[ratio];
                designerCanvasStore.setCanvasSize(
                  {
                    width: dimensions.width,
                    height: dimensions.height,
                  },
                  true,
                );
              }
            }}
            options={BACKGROUND_RATIO_OPTIONS}
            size="sm"
            buttonClassName="w-[94px]"
            align="end"
          />
        }
      >
        <div className="flex-row gap-200 items-center">
          <div className="flex-fill">
            <InputNumber
              value={canvasSize?.width ?? 0}
              onChange={(width) =>
                designerCanvasStore.setCanvasSize(
                  {
                    width,
                    height: canvasSize?.height ?? 0,
                  },
                  true,
                )
              }
              min={1}
              max={MAX_PIXEL_DIMENSION}
              suffix="px"
            />
          </div>
          <span className="text-secondary body-sm-default">×</span>
          <div className="flex-fill">
            <InputNumber
              value={canvasSize?.height ?? 0}
              onChange={(height) =>
                designerCanvasStore.setCanvasSize(
                  {
                    width: canvasSize?.width ?? 0,
                    height,
                  },
                  true,
                )
              }
              min={1}
              max={MAX_PIXEL_DIMENSION}
              suffix="px"
            />
          </div>
        </div>
      </PanelSubsection>
    </PanelSection>
  );
};
